import { IPROP_MAP, modifyProps } from '../../generators/modifyProps';

import { JDSSidePanelProps } from './generated';
import { ListBlockProps } from '../jdslistblock/logic';
import { Text } from '../jdstext/generated';
import { convertTextToComponent } from '../../utils/componenthelpers';
import { getPlatform } from '../../utils';
import { useTransition } from '../../hooks/useTransition';

export interface SidePanelProps
  extends Omit<
    JDSSidePanelProps,
    | 'header'
    | 'onClose'
    | 'platform'
    | 'items'
    | 'onContainerClick'
    | 'onSidePanelSuffixClick'
  > {
  /**
   * Header to be displayed
   *
   * Passing listblock props are deprecated. Pass a text elment
   */
  header?: JDSSidePanelProps['header'] | ListBlockProps;
  /**
   * Event that gets triggered when `close` button clicked
   */
  onClose?: () => void;
  /**
   * Defines if transition should be disabled, if set to true panel will not slide but appear instantly
   */
  disableTransition?: boolean;
}

export const PROP_MAP: IPROP_MAP<SidePanelProps> = (props) => {
  if ((props.header as ListBlockProps)?.title) {
    console.warn('passing listblock props to header is deprecated');
  }
  return {
    header: {
      properties: {
        prefix: (props.header as ListBlockProps)?.prefix,
        header:
          (props.header as ListBlockProps)?.titleBlock?.text ||
          ((props.header as ListBlockProps)?.title ? (
            <Text>{(props.header as ListBlockProps)?.title}</Text>
          ) : (
            props.header
          ))
      }
    },
    maxWidth: {
      properties: {
        maxWidth: !props.maxWidth
      }
    }
  };
};

export const withLogic =
  (Component: React.ComponentType<SidePanelProps>): React.FC<SidePanelProps> =>
  (userProps: SidePanelProps) => {
    const props = modifyProps(userProps, PROP_MAP);
    const { className, open, close } = useTransition(
      Boolean(props.open),
      props.onClose,
      500
    );

    const directionClass = props.direction === 'right' ? 'right' : '';

    const classes = [
      directionClass,
      className,
      !props.disableTransition ? 'enable-transition' : ''
    ];
    return (
      <Component
        {...{
          ...props,
          open,
          maxWidth: props.maxWidth || props.maxWidth === undefined,
          platform: getPlatform(),
          children: convertTextToComponent(props.children),
          className: classes.join(' '),
          _onContainerClick: (ev: React.MouseEvent<HTMLDivElement>) => {
            ev.stopPropagation();
          },
          onClose: close
        }}
      />
    );
  };
